<ng-container *ngIf="!isWebWidget">
  <customer-portal-app-revolution-main-view
    [view]="view"
  ></customer-portal-app-revolution-main-view>
</ng-container>

<ng-container *ngIf="isWebWidget">
  <customer-portal-revolution-login-webwidget
    *ngIf="view === 'login'"
  ></customer-portal-revolution-login-webwidget>
  <customer-portal-app-revolution-main-view
    *ngIf="view !== 'login'"
    [view]="view"
  ></customer-portal-app-revolution-main-view>
</ng-container>

<customer-portal-ef-spinner-dialog
  *ngIf="showTransifexSpinner"
></customer-portal-ef-spinner-dialog>
